import { render, staticRenderFns } from "./voiceCardView.vue?vue&type=template&id=60b0ac8a&scoped=true"
import script from "./voiceCardView.vue?vue&type=script&lang=js"
export * from "./voiceCardView.vue?vue&type=script&lang=js"
import style0 from "./voiceCardView.vue?vue&type=style&index=0&id=60b0ac8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b0ac8a",
  null
  
)

export default component.exports